
import { gameRunManager } from '../services/run_manager'
import { useSyncExternalStore } from 'react'
import { Button } from './ui/button'
import React from 'react'

const TITLE = "Yadda Yadda"

const titleStyle: React.CSSProperties = {
	fontSize: "100px",
	fontWeight: "bold",
	textAlign: "center",
	color: "#000000",
}

const startStyle: React.CSSProperties = {
	fontSize: "100px",
	fontWeight: "bold",
	textAlign: "center",
	color: "white",
	backgroundColor: "black",
	border: "3px solid black",
	borderRadius: "5px",
	padding: "10px",
	paddingLeft: "20px",
	paddingRight: "20px",
	cursor: "pointer",
}

export const PreGame = () => {
	const gameRun = useSyncExternalStore(gameRunManager.subscribe, gameRunManager.getSnapshot);
	return (
		<div>
			<h1 style={titleStyle}>{TITLE}</h1>
			<Button style={startStyle} onClick={() => {
				gameRunManager.startGame();
			}}>Start Game</Button>
		</div>
	)
}